import { get, post, put, del } from '../../api-config';
import { gdpService } from './_service';

// Notas de llamada con IA (contrato en AI_NOTAS_LLAMADA_PLAN.md). El token lo inyecta el
// interceptor de api-config.ts.

// Config por grupo (herencia por ascenso como la FHIR: PUT crea/sustituye la fila PROPIA,
// DELETE vuelve a heredar). ADMIN solo lectura; SUPERADMIN edita.
export const getGroupAiNotesConfig = (groupId: string) => get(gdpService, `/groups/${groupId}/ai-notes-config`);
export const putGroupAiNotesConfig = (groupId: string, data: any) =>
  put(gdpService, `/groups/${groupId}/ai-notes-config`, data);
export const deleteGroupAiNotesConfig = (groupId: string) => del(gdpService, `/groups/${groupId}/ai-notes-config`);

// Consumo agregado del subárbol por mes (from/to en YYYY-MM) y llamadas procesadas de un mes.
export const getGroupAiNotesUsage = (groupId: string, from: string, to: string) =>
  get(gdpService, `/groups/${groupId}/ai-notes/usage`, null, { from, to });
export const getGroupAiNotesCalls = (groupId: string, month: string, page: number, size: number) =>
  get(gdpService, `/groups/${groupId}/ai-notes/calls`, null, { month, page, size });

// Notas IA del operador: las del expediente (la más reciente primero), la de una llamada (sondeo
// en vivo: item null si no hay) y aceptar (note opcional: igual al borrador → ACCEPTED, distinta →
// EDITED) o descartar.
export const getExpedientAiNotes = (expedientId: string) => get(gdpService, `/expedients/${expedientId}/ai-notes`);
export const getAiNote = (eventId: string) => get(gdpService, `/ai-notes/${eventId}`);
export const postAiNoteAccept = (eventId: string, note?: string | null) =>
  post(gdpService, `/ai-notes/${eventId}/accept`, note != null ? { note } : {}, null);
export const postAiNoteDiscard = (eventId: string) => post(gdpService, `/ai-notes/${eventId}/discard`, {}, null);
